const searchInitialState = {
  searchQuery: '',
  searchResults: [],
};

// Search reducer gets all favourites and searches facts in favourites or from api
export default function searchReducer(state = searchInitialState, action) {
  return state
}
